










































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  props: ['url', 'hash', 'text', 'tag', 'isWhite', 'isFv', 'isHeader', 'linkHeight', 'isTopRecruit'],
})
export default class ButtonDefault extends Vue {}
